'use es6';

export const requiredReportOrDashboardPropCheck = (props, componentName) => {
  if (!props.report && !props.dashboard) {
    return new Error(`One of 'report' or 'dashboard' is required by ${componentName} component.`);
  }
  return null;
};